module.exports = __webpack_public_path__ + "img/YNGCommunitySite.882f22eb.svg";